// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resource-availability[data-v-87852cf6]{align-self:center}.row[data-v-87852cf6]{display:flex;flex-direction:row;justify-content:space-evenly}.row>*[data-v-87852cf6]{width:100%}", ""]);
// Exports
module.exports = exports;
